import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";


export const UserlikedVideos = createAsyncThunk(
  "UserlikedVideos",
  async ({ nextUrl, isLoadMore = false } = {}) => {
    try {
      let response;
      if (nextUrl) {
        // Extract path from full URL
        const url = new URL(nextUrl);
        const pathAndQuery = url.pathname + url.search;
        const relativePath = pathAndQuery.replace('/api', '');
        response = await axiosInstance.get(relativePath);
      } else {
        response = await axiosInstance.get(`/post/my_likes/`);
      }
      return { data: response.data, isLoadMore };
    } catch (error) {
      throw error;
    }
  }
);

export const userLikedPosts = createSlice({
  name: "userLikedPosts",
  initialState: {
    User_likedVideos: [],
    loading: false,
    loadingMore: false,
    nextPage: null,
    error: null,
  },
  reducers: {
    resetLoadingMore: (state) => {
      state.loadingMore = false;
    },
  },
  extraReducers: (builder) => {
    // account page UserlikedVideos action promise
    builder.addCase(UserlikedVideos.pending, (state, action) => {
      const isLoadMore = action.meta.arg?.isLoadMore;
      if (isLoadMore) {
        state.loadingMore = true;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(UserlikedVideos.fulfilled, (state, action) => {
      const { data, isLoadMore } = action.payload;
      state.loading = false;
      state.loadingMore = false;

      if (isLoadMore) {
        // Append new posts to existing ones
        const existingPosts = state.User_likedVideos || [];
        const newPosts = data?.results?.liked_posts || [];
        state.User_likedVideos = [...existingPosts, ...newPosts]

      } else {
        // Replace with new data
        state.User_likedVideos = data.results.liked_posts;
      }

      // Update pagination info
      state.nextPage = data?.next || null;
    });
    builder.addCase(UserlikedVideos.rejected, (state, action) => {
      state.loading = false;
      state.loadingMore = false;
      state.error = action.error?.message || "Failed to load liked videos";
    });

  },
});

export const { resetLoadingMore } = userLikedPosts.actions;
export default userLikedPosts.reducer;
